var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import BaseChart from "./BaseChart";
import "./registerDefaults";
import { getChartAdapter } from "./registry";
function deepMerge(base, patch) {
    if (!patch) {
        return __assign({}, base);
    }
    var result = __assign({}, base);
    Object.entries(patch).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (value === undefined) {
            return;
        }
        var baseValue = base[key];
        if (value &&
            typeof value === "object" &&
            !Array.isArray(value) &&
            baseValue &&
            typeof baseValue === "object" &&
            !Array.isArray(baseValue)) {
            result[key] = deepMerge(baseValue, value);
        }
        else {
            result[key] = value;
        }
    });
    return result;
}
var CompsChart = function (_a) {
    var type = _a.type, data = _a.data, settings = _a.settings, className = _a.className, style = _a.style, theme = _a.theme, loading = _a.loading, events = _a.events;
    var adapter = useMemo(function () { return getChartAdapter(type); }, [type]);
    var resolvedSettings = useMemo(function () {
        var _a, _b;
        var defaults = (_b = (_a = adapter.getDefaultSettings) === null || _a === void 0 ? void 0 : _a.call(adapter)) !== null && _b !== void 0 ? _b : {};
        return deepMerge(defaults, settings);
    }, [adapter, settings]);
    var option = useMemo(function () {
        return adapter.buildOption({
            chartType: type,
            data: data,
            settings: resolvedSettings,
            theme: theme,
        });
    }, [adapter, data, resolvedSettings, theme, type]);
    return (_jsx(BaseChart, { option: option, className: className, style: style, theme: theme, eventHandlers: events, loading: loading }));
};
export default CompsChart;
export { registerChartAdapter, listChartTypes, isChartTypeRegistered, } from "./registry";
